import styled, { css } from 'styled-components';

export const Header = styled.div`
  padding: 10px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  > div {
    font-size: 20px;
    font-weight: 600;
  }
  @media screen and (max-width: 700px) {
    ${props =>
      props.permission &&
      css`
        flex-direction: column;
        align-items: self-start;
        padding: 0px 10px;
        justify-content: space-evenly;
      `}
  }
`;
